import React, { useState, useEffect } from "react";
import { InputFL, ValidationSummary } from "Components/Inputs";
import { Button, Modal, ModalBody, Row, ModalHeader, SpinningButton } from "Components/ReactstrapSlim";
import { SupportModalProps, useSupportModal } from "./Main/SupportModal";

interface GetHelpModalProps extends SupportModalProps {

}

const GetHelpModal: React.FC<GetHelpModalProps> = ({ isOpen, closeModal, onRequested, ...modalProps }) => {
   const [isSucess, setIsSuccess] = useState<boolean>(false);
   const onRequestedWrapped = () => {
      setIsSuccess(true);
      if (onRequested)
         onRequested();
   }

   const { closeModalInternal, formMethods, onSubmit, serverError, isSaving } = useSupportModal({ isOpen, closeModal, onRequested: onRequestedWrapped });

   useEffect(() => {
      if (isOpen) {
         setIsSuccess(false);
      }
   }, [isOpen])

   return <Modal className="modal-lg support-modal" isOpen={isOpen} {...modalProps}>
      <ModalHeader toggle={closeModalInternal}>
         {isSucess ? null : "How can we help?"}
      </ModalHeader>
      {isSucess ?
         <ModalBody className="support-modal-success">
            <div className="success-img"></div>
            <div className="success-title">Your message has been sent!</div>
            <div className="success-subtitle">Our team has received your message and will respond within one business day.</div>
         </ModalBody>
         : <ModalBody>
            <div className="p2 tc-secondary">
               Send a message to the LiquidSpace support team to let us know how we can help.
            </div>
            <form onSubmit={formMethods.handleSubmit(onSubmit)}>
               <InputFL name="message" control={formMethods.control} placeholder="Message" type="textarea" />
               <ValidationSummary errors={formMethods.formState.errors} fields={["message"]} serverErrors={serverError} />
               <Row className="d-flex justify-content-end support-modal-buttons">
                  <Button onClick={closeModalInternal} color="secondary" size="lg" className="mr-3 mt-3">Back</Button>
                  <SpinningButton isLoading={isSaving} color="primary" size="lg" className="ml-3 mt-3">Send Message</SpinningButton>
               </Row>
            </form>
         </ModalBody>
      }
   </Modal>
}

export default GetHelpModal;